<template>
    <router-link :to="`/material-public/${item?.id}`" class="card" style="border-radius: 10px; overflow: hidden;">
        <div :style="{
            backgroundImage: `url('${item.main_image ? item.main_image : '/assets/img/empty.png'}')`,
            height: '200px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }" :class="{ 'no-stock': item?.storage?.stock === 0 }">
            <div class="d-flex justify-content-between align-middle m-1">
                <span class="available-badge text-sm">
                    {{ item?.storage?.stock === 0 ? "Tidak Tersedia" : "Tersedia" }}
                </span>
                <span class="btn btn-icon-small rounded-circle" style="cursor: pointer; background-color: aliceblue;" @click.stop.prevent="onBookmark">
                    <i class="fa fa-lg text-blue" :class="isBookmarked(item.id) ? 'fa-bookmark' : 'fa-bookmark-o'"></i>
                </span>
            </div>
        </div>

        <div class="card-body" :class="{ 'no-stock': item?.storage?.stock === 0 }">
            <h1 class="card-title text-truncate">
                {{ item?.name }}
            </h1>
            <p>{{ item.id }}</p>
            <div class="text-muted small mb-1">
                {{ item?.category?.name }} | {{ item?.sub_category?.name }}
            </div>
            <div class="mb-1">
                <i class="fa fa-home fa-lg mr-1" style="color: lightslategray;"></i>
                <span style="color: black;">
                    {{ item?.storage?.warehouse?.name }}
                </span>
            </div>
            <div class="stock-badge mb-1">
                Stok : {{ item?.storage?.stock }} pcs
            </div>
            <div>
                <i class="fa fa-map-marker fa-lg mr-1" style="color: lightslategray;"></i>
                <span style="color: black;">
                    {{ item?.storage?.unit?.name }}
                </span>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "MaterialCard",
    props: {
        item: {
            type: Object,
            required: true
        },
        useAction: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onBookmark() {
            this.$emit('bookmark', this.item)
        },
        isBookmarked(id) {
            const bookmarkIds = JSON.parse(localStorage.getItem('material_public_bookmarked')) ?? []
            return bookmarkIds.includes(id)
        }
    }
}
</script>



<style>
 .available-badge {
    background-color: rgb(21, 133, 11);
    padding: 3px 10px;
    border-radius: 10px;
    color: white;
    display: inline-flex; /* Ubah dari inline-block */
    align-items: center; /* Rata tengah vertikal */
    justify-content: center; /* Rata tengah horizontal */
    height: 27px; /* Beri tinggi tetap (opsional) */
}

.stock-badge {
    background-color: rgb(218, 241, 250);
    padding: 5px 10px 5px 10px;
    border-radius: 5px;
    color: rgb(25, 125, 167);
    font-weight: bold;
    width: fit-content;
}

.no-stock {
  background-color: #f8f9fa !important; /* abu muda */
  color: #6c757d !important; /* teks abu */
  filter: grayscale(100%); /* efek hitam putih */ 
}

</style>